import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { APPLICATION_INSIGHTS_CONNECTION_STRING } from 'src/environments/environment';
import { UserSessionService } from '@modules/common/services/user-session.service';

@Injectable({
    providedIn: 'root'
})
export class AppInsightsService {
    private _appInsights?: ApplicationInsights;

    constructor(private readonly _userSessionService: UserSessionService) { }

    public initialize(): void {
        try {
            if (APPLICATION_INSIGHTS_CONNECTION_STRING) {
                this._appInsights = new ApplicationInsights({
                    config: {
                        connectionString: APPLICATION_INSIGHTS_CONNECTION_STRING,
                        extensionConfig: {
                            AppInsightsCfgSyncPlugin: {
                                cfgUrl: '' //Prevent loading a file from MS CDN - https://github.com/microsoft/ApplicationInsights-JS/blob/main/docs/WebConfig.md#disable-fetching-from-cdn
                            }
                        }
                    }
                });

                this._appInsights.loadAppInsights();

                this._appInsights.addTelemetryInitializer(envelope => {
                    envelope.data ||= {};
                    envelope.data.UserId_CF = this._userSessionService.getUserSession()?.userInfo?.id?.toString();
                    envelope.data.Email_CF = this._userSessionService.getUserSession()?.userInfo?.emailAddress;
                });
            }
        } catch (e) {
            console.error('Application Insights failed to start ' + e);
            this._appInsights = undefined;
        }
    }

    public trackException(exception: Error): void {
        this._appInsights?.trackException({
            exception: exception
        });
    }
}
